<template lang="pug">
	.dropdown-display-object-type-text
		.dropdown-control(:class="{active: active}" v-pseudo-modal-show="this._uid + '-dropdown-display-object-type-text'")
			.icon.fa.fa-font
			.value Add text
			.drop-icon.fa.fa-caret-down
		.dropdown-menu(v-pseudo-modal="this._uid + '-dropdown-display-object-type-text'" :style="{'max-height': `90vh`}" v-on:mouseover="active = true" v-on:mouseout="active = false")
			.dropdown-header
				.property-title {{Metadata.DisplayObjectsByCodename['text'].title}}
				.property-description {{Metadata.DisplayObjectsByCodename['text'].description}}
			.dropdown-item(v-for="message in messages" @click="selectLocalization(message)")
				.fa.fa-font
				.asset-codename {{message.codename}}
			.dropdown-footer
				.add-message-container
					input.style-input.form-control.form-control-sm(type="text" placeholder="Write a new message here" v-model="newMessage")
					button.btn.btn-sm.btn-ghost-secondary(v-on:click="addLocalization")
						i.fa.fa-plus
</template>

<script>
	import Screen from './../../mixins/screen'

	export default {
		name: 'DropdownDisplayObjectTypeText',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Localization Changed"
			]
		},
		props: {

		},
		data() {

			this.messages = [];

			return {
				showed: true,
				newMessage: '',
				active: false
			};

		},
		methods: {
			collectData() {

				this.messages = Localization.getVersionLocalization(Version.SelectedVersion).en;

			},
			selectLocalization(message) {

				this.$emit('select', {localizationCodename: message.codename});

				Broadcast.call("Pseudo Modal Hide", [this._uid + '-dropdown-display-object-type-text']);

			},
			addLocalization() {

				if (!this.newMessage) return;

				Server.sendToSocket({
					CreateLocalizationMessage: {
						versionId: Version.SelectedVersion.id,
						locale: 'en',
						message: this.newMessage
					}
				});

				this.newMessage = '';

				Broadcast.once("Selected Version Localization Changed", (versionId, locale, localizationCodename) => {

					this.$emit('select', {localizationCodename: localizationCodename});

					Broadcast.call("Pseudo Modal Hide", [this._uid + '-dropdown-display-object-type-text']);

				}, "Dropdown Display Object Type Text");

			}
		}
	}
</script>

<style lang="sass">

	.dropdown-display-object-type-text
		position: relative
		margin-top: 1px
		user-select: none

		.dropdown-control
			border: 1px solid rgba(255, 255, 255, 0.1)
			border-radius: 0.25rem
			background: rgba(255, 255, 255, 0.05) no-repeat
			background-position-x: right 0.75rem
			background-position-y: calc(50% - 1px)
			background-size: 8px 10px
			padding-top: 4px
			padding-bottom: 4px
			padding-right: 2rem
			padding-left: 0.5rem
			color: rgba(255, 255, 255, 0.5)
			cursor: pointer
			font-size: 12px
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			align-items: center

			.icon
				margin-top: 2px

			.value
				overflow: hidden
				text-overflow: ellipsis
				white-space: nowrap
				margin-left: 7px

			.drop-icon
				position: absolute
				right: 13px
				top: 8px
				color: rgba(255, 255, 255, 0.50)

		.dropdown-control:hover, .dropdown-control.active
			border: 1px solid #20a8d8
			background: rgba(255, 255, 255, 0.1) no-repeat

			.icon, .value, .drop-icon
				color: #20a8d8

		.dropdown-menu
			top: auto
			bottom: 30px
			border-color: #3f454b
			width: 240px
			margin: 0
			padding: 0

			.dropdown-header
				cursor: default
				display: flex
				flex-direction: column
				justify-content: start
				padding: 0.25rem
				padding-left: 0.55rem
				font-size: 0.765625rem
				border-bottom: 1px solid #3f454b
				background-color: #555b5f

				.property-title
					color: rgba(255,255,255,1)
					width: calc(240px - 20px)
					overflow: hidden
					text-overflow: ellipsis
					margin-left: 0
					white-space: nowrap
					font-size: 13px

				.property-description
					width: calc(250px - 20px)
					margin-left: 0
					white-space: normal
					font-size: 11px
					color: rgba(255,255,255,0.4)

			.dropdown-item
				display: flex
				flex-direction: row
				justify-content: start
				padding: 0.25rem
				padding-left: 0.55rem
				font-size: 0.765625rem
				border-bottom: 1px solid #3f454b
				background-color: #555b5f

				&:last-child
					border-bottom: none

				&:hover
					background-color: #646a6f

				.fa
					display: flex
					align-items: center
					justify-content: center

				.asset-codename
					width: 160px
					overflow: hidden
					text-overflow: ellipsis
					margin-left: 7px

			.dropdown-footer
				background-color: #555b5f

			.add-message-container
				display: flex
				flex-direction: row
				white-space: nowrap

				input
					border: 0
					border-radius: 0
					background-color: transparent
					outline: none
					box-shadow: none

				input::placeholder
					color: rgba(255,255,255,0.3)

				button
					border-radius: 3px
					outline: none
					box-shadow: none

					i


</style>
